<div class="td-wb-loading-indicator-panel">
  @if (customLoadingIndicator()) {
    <ng-content></ng-content>
  } @else {
    <td-wb-loading-indicator class="td-wb-loading-indicator-panel__default"
                             position="top" />
  }
</div>

